import { hideFeaturesForNonAdminAndSuperAdmin } from './common-utils-module.js';

/**
 * Render a table with templates on the template tab
 */
export function renderTable(result) {
  let str = '';
  let list = result.public_ppt_list;
  $('#public_w_templates_table tbody tr').remove();
  for (let i = 0; i < list.length; i += 1) {
    str +=
      `<tr id='templ_${list[i].id}'><td>${i + 1}</td><td>${list[i].name}</td><td>${list[i].organisation_name}</td><td>${
        list[i].placeholder_counts
      }</td><td>${list[i].created_date.substr(0, 10)}</td><td>${list[i].updated_date.substr(
        0,
        10
      )}</td><td align='left'>` +
      `<button  type="button" title="Preview" class="btn btn-info btn-sm  fullWidth" onclick="previewPhotoTemplate(${list[i].id})" ><i class="fas fa-eye"></i></button>` +
      `&nbsp;&nbsp;&nbsp;` +
      `<button  type="button" title="Edit" class="btn btn-info btn-sm  fullWidth SUPERUSER" onclick="editPhotoTemplate(${list[i].id})" ><i class="fas fa-pen"></i></button>` +
      `&nbsp;&nbsp;&nbsp;` +
      `<button  type="button" title="Delete" class="btn btn-danger btn-sm  fullWidth SUPERUSER" onclick="deletePhotoTemplate(${list[i].id})" ><i class="fas fa-trash-alt"></i></button></td></tr>`;
  }
  $('#public_w_templates_table tbody').append(str);

  str = '';
  list = result.private_ppt_list;
  $('#private_w_templates_table tbody tr').remove();
  for (let k = 0; k < list.length; k += 1) {
    str +=
      `<tr id='templ_${list[k].id}'><td>${k + 1}</td><td>${list[k].name}</td><td>${list[k].organisation_name}</td><td>${
        list[k].placeholder_counts
      }</td><td>${list[k].created_date.substr(0, 10)}</td><td>${list[k].updated_date.substr(
        0,
        10
      )}</td><td align='left'>` +
      `<button  type="button" title="Preview" class="btn btn-info btn-sm  fullWidth" onclick="previewPhotoTemplate(${list[k].id})" ><i class="fas fa-eye"></i></button>` +
      `&nbsp;&nbsp;&nbsp;` +
      `<button  type="button" title="Edit" class="btn btn-info btn-sm  fullWidth" onclick="editPhotoTemplate(${list[k].id})" ><i class="fas fa-pen"></i></button>` +
      `&nbsp;&nbsp;&nbsp;` +
      `<button  type="button" title="Delete" class="btn btn-danger btn-sm fullWidth" onclick="deletePhotoTemplate(${list[k].id})" ><i class="fas fa-trash-alt"></i></button></td></tr>`;
  }
  $('#private_w_templates_table tbody').append(str);
  hideFeaturesForNonAdminAndSuperAdmin();
}

export function openTemplatePage() {
  const win = window.open('templates/?watermark=1', '_blank');
  win.focus();
}

/**
 * Open the page to edit template
 *
 * @param {Number} id
 */
export function editTemplate(id) {
  const win = window.open(`templates/?tid=${id}&watermark=1`, '_blank');
  win.focus();
}

/**
 * Open the page to preview template
 *
 * @param {Number} id
 */
export function previewTemplate(id) {
  const win = window.open(`templates/?tid=${id}&mode=preview`, '_blank');
  win.focus();
}

/**
 * Delete template by id
 *
 * @param {Number} id
 */
export function deleteTemplate(id) {
  if (confirm(LANG.delete_this_template)) {
    showLoading();
    occoApi.pptDelete(id, (err) => {
      if (err) {
        alertMessagePopup(err.message_key);
        refreshPage('pptDelete');
        return;
      }
      hideLoading();
      $(`#templ_${id}`).remove();
    });
  }
}

window.editPhotoTemplate = editTemplate;
window.previewPhotoTemplate = previewTemplate;
window.deletePhotoTemplate = deleteTemplate;
